<!-- VR专区 -->
<template>
  <div class='inside-component'>
    <!-- 上滑加载组件 -->
    <cp-page-scroll
      v-show="courseList.length"
      @load="load"
      :upFinish="upFinish"
      :isref="isref"
      ref="pageScroll"
    >
      <div class="vr-course">
        <div class="course-list" v-if="courseList.length">
          <div class="course-item" v-for="(item,index) in courseList" :key="index">
            <img src="./../../../assets/images/icon/vrkc_dt.png" />
            <h3 class="title" v-text="item.appMainName"></h3>
            <div class="video-item">
              <img class="bgImg" v-if="item.currentSwiperItem && item.currentSwiperItem.listImg" :src="formatAliyunPath(item.currentSwiperItem.listImg)" :alt="item.name" style="width:100%; height:100%; object-fit:fill"/>
              <video v-else-if="item.currentSwiperItem && item.currentSwiperItem.videoSrc" :src="formatAliyunPath(item.currentSwiperItem.videoSrc)" class="video_back" muted autoplay="autoplay" loop="loop"
                style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
              </video>
              <video v-else class="video_back" src="./../../../assets/video/default.mp4" type="video/mp4"  muted autoplay="autoplay" loop="loop"
                style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
              </video>
              <div class="masking"></div>
              <div class="session-contain" v-if="item.currentSwiperItem">
                <p class="session-title">{{ item.currentSwiperItem.name }}</p>
                <div class="btn" @click="onVrExperience(item)">
                  <img src="./../../../assets/images/icon/vr_button.png" />
                  <p>头盔模式</p>
                </div>
              </div>
              <div class="swiper-contains" v-if="item.displayDimension==2">
                <swiper v-if="item.detailList.length" :options="item.swiperOption" :ref="item.refCourseSwiper">
                  <swiper-slide v-for="(itemChild,index) in item.detailList" :key="index" :data-id="itemChild.id">
                    <img class="swiper-slide" :src="itemChild.listImg ? formatAliyunPath(itemChild.listImg) : formatAliyunPath(itemChild.videoSrc) + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_192,h_108'" />
                    <p class="title" v-text="itemChild.name"></p>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cp-page-scroll>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { course, aliyun, home } from '@/agent'
export default {
  name: 'VrCourse',
  props: {
    tabIndex: {
      type: String,
      default: ''
    }
  },
  computed: {
  },
  data () {
    // eslint-disable-next-line no-unused-vars
    const that = this
    return {
      courseList: [],
      params: {
        pageNum: 1,
        pageSize: 10,
        query: {
          appType: 1 // (此处指定VR一体机课程)
        },
      },
      upFinish: false, // 是否已加载全部
      isref: true, // 节流
    }
  },
  components: {},
  mounted () {
    this.getForVRSpecial()
  },
  methods: {
    // VR专区-头盔体验
    onVrExperience (item) {
      console.log(item)
      const param = {
        app: item.appMainParams,
        msg: 'OpenAppAndScene',
        point: item.displayDimension === 1 ? 0 : item.currentSwiperItem.point,
        scene: item.displayDimension === 1 ? 0 : item.currentSwiperItem.params
      }
      home.getSocketapiVr(param).then((res) => {
        if (res.data.data == 100) {
          Toast.success(res.data.data)
        } else {
          Toast.fail(res.data.msg)
        }
      })
    },
    // 获得vr专区 场景模块  获取场景列表分页
    getForVRSpecial (resetList = false) {
      this.$loading.show()
      course.getForVRSpecial(this.params).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.courseList = resetList ? res.data.list : [...this.courseList, ...res.data.list]
          let that = this
          this.courseList = this.courseList.map((item, index) => {
            item.refCourseSwiper = 'courseSwiper_' + index
            if (item.displayDimension == 2) { // 直接获取 detailList-场景
              item.currentSwiperItem = item.detailList[0]
              item.swiperOption = {
              // 可见图片张数
                slidesPerView: 3,
                // 默认选中中间一张
                centeredSlides: 1,
                // 无限循环
                loop: true,
                // 自动轮播
                autoplay: true,
                on: {
                  slideChange: function () {
                  // console.log(this.activeIndex)
                  // console.log(that.$refs['courseSwiper_'+index][0].swiper)
                    let id = that.$refs['courseSwiper_' + index][0].swiper.slides[this.activeIndex].attributes['data-id'].value
                    /**
                     * id 选中的轮播项的id
                     * index 当前轮播组件位与courseList数组的下标的位置
                     */
                    that.swiperIndexChange(index, that.courseList[index].detailList, id)
                  }
                },
              }
            } else if (item.displayDimension == 1) { // 获取item中的属性作为 detailList的第一个-应用
              let obj = {
                videoSrc: item.videoSrc,
                listImg: '',
                description: item.appMainDescription,
                name: item.appMainName
              }
              item.currentSwiperItem = obj
            }
            return item
          })
          this.$forceUpdate()
          if (this.params.pageNum >= res.data.pages) {
            this.upFinish = true
            this.isref = false
          } else {
            this.params.pageNum += 1
            this.upFinish = false
            this.isref = true
          }
        } else {
          this.isref = false // 请求失败下次不可以请求
          this.upFinish = true// 显示 没有更多了
        }
        this.$refs.pageScroll.hideLoading() // 底部加载loading隐藏
      })
    },
    swiperIndexChange (index, list, id) {
      let currentSwiperItem = {}
      for (let i = 0; i < list.length; i++) {
        if (id == list[i].id) {
          currentSwiperItem = list[i]
          break
        }
      }
      let obj = this.courseList[index]
      obj.currentSwiperItem = JSON.parse(JSON.stringify(currentSwiperItem))
      this.$set(this.courseList, index, obj)// 重点
    },
    load () {
      // 防止多次上滑动导致page等于2没加载出来就加载page等于3的内容
      this.getForVRSpecial()
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}

</script>
<style lang='scss' scoped>
.inside-component{
  width:100%;
  background: #060A13;
  // padding:20px 0;
  .course-list{
    .course-item{
      position: relative;
      img{
        width: 100%;
        height: auto;
        display: block;
      }
      .title{
        position: absolute;
        top: 12px;
        left: 20px;
        font-size: 28px;
        font-family: YouSheBiaoTiHei;
        font-weight: 600;
        color: #FEFEFE;
        opacity: 0.1;
        margin-bottom: 15px;
      }
      .video-item{
        width: 320px;
        height: 180px;
        position: absolute;
        top: 54%;
        left: 50%;
        transform: translate(-50%,-50%);
        .masking{
          width: 320px;
          height: 180px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          background: rgba(0, 0, 0, 0.6);
        }
        .bgImg{
          width:100%;
          height:100%;
          display: block;
        }
        .session-contain{
          position: absolute;
          top: 35%;
          left: 50%;
          transform: translate(-50%,-50%);
          .session-title{
            font-size: 22px;
            font-family: YouSheBiaoTiHei;
            font-weight: 600;
            color: #fefefe;
            margin-bottom: 15px;
            text-align: center;
          }
          .btn{
            position: absolute;
            left: 50%;
            top: 60%;
            transform: translate(-50%,0);
            width: 100px;
            font-size: 10px;
            font-family: Source Han Sans CN;
            border-radius: 1px;
            text-align: center;
            line-height: 24px;
            color: #F2F2F2;
            p{
              position: absolute;
              top: 43%;
              left: 50%;
              transform: translate(-50%,-50%);
              opacity: 1;
              font-size: 10px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: center;
              color: #ffffff;
            }
          }
        }
        .swiper-contains{
          width:100%;
          height: 73px;
          position: absolute;
          bottom: -8%;
          .swiper-container{
            width:100%;
            height: 73px;
            .title{
              position: absolute;
              top: 50%;
              left: 0;
              transform: translate(0,-50%);
              width: 100%;
              opacity: 1;
              font-size: 10px;
              font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
              font-weight: 400;
              text-align: center;
              color: #f2f2f2;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              padding:0 10px;
              box-sizing: border-box;
            }
            .title2{
              position: absolute;
              top: 10%;
              left: 10%;
              transform: translate(0,-50%);
              width: 100%;
              opacity: 1;
              font-size: 10px;
              font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
              font-weight: 400;
              text-align: center;
              color: #f2f2f2;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              padding:0 10px;
              box-sizing: border-box;
            }
            .top-title{
              font-size: 22px;
              font-family: YouSheBiaoTiHei;
              font-weight: 600;
              color: #fefefe;
              margin-bottom: 15px;
              text-align: center;
              position: absolute;
              top: -100%;
              left: 0;
              transform: translate(0,-50%);

            }
          }
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.vr-course{
  .swiper-slide{
    transition:1s;
    transform: scale(0.8) translate(0,12%);
    // transform: scale(0.85);
  }
  //swriper自带的类名（选中时的样式）
  .swiper-slide-active,.swiper-slide-duplicate-active {
    transform: scale(1.3);
  }
}
</style>
